import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	enableBackground: "new 0 0 32 32",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m16 31.36c-8.47 0-15.36-6.89-15.36-15.36s6.89-15.36 15.36-15.36 15.36 6.89 15.36 15.36-6.89 15.36-15.36 15.36zm-9.651-4.36c2.579 2.266 5.957 3.64 9.651 3.64 3.693 0 7.072-1.374 9.65-3.64h-.01c0-4.341-2.941-8.161-7.153-9.29-.144-.038-.248-.16-.265-.307-.018-.146.058-.289.188-.358 1.678-.897 2.72-2.635 2.72-4.534 0-2.84-2.306-5.151-5.14-5.151s-5.141 2.311-5.141 5.151c0 1.899 1.042 3.637 2.72 4.534.13.069.205.212.188.358s-.122.269-.264.307c-4.201 1.125-7.133 4.945-7.133 9.29zm13.086-9.75c3.913 1.377 6.646 4.973 6.905 9.104 2.655-2.651 4.3-6.314 4.3-10.354 0-8.073-6.567-14.64-14.64-14.64s-14.64 6.567-14.64 14.64c0 4.04 1.645 7.703 4.3 10.354.258-4.135 2.982-7.729 6.883-9.104-1.506-1.094-2.415-2.846-2.415-4.739 0-3.237 2.629-5.871 5.86-5.871 3.232 0 5.861 2.633 5.861 5.871.001 1.893-.908 3.645-2.414 4.739z",
		strokeWidth: 20,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m0 0h32v32h-32z",
		fill: "none"
	})]
});
export default SvgUser;
